exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-container[data-v-e2f01502] {\n  height: 150px;\n  text-align: center;\n}\n.upload-container .gray-text[data-v-e2f01502] {\n    margin-bottom: 10px;\n}\n.upload-container img[data-v-e2f01502] {\n    max-height: 100%;\n}\n.upload-container > div .custom-btn[data-v-e2f01502] {\n    max-width: initial;\n    background-color: #2b93ff;\n}\n.upload-container > div[data-v-e2f01502] {\n    height: initial;\n}\n", ""]);

// exports
